import { ApolloClient, gql } from 'apollo-boost';

const mutation = gql`
  mutation deleteAllocation($allocationId: Int!) {
    deleteAllocation(id: $allocationId) {
      success
    }
  }
`;

interface DeleteAllocationVariables {
  allocationId: number | string;
}

export interface DeleteAllocationResponse {
  deleteAllocation: {
    success: boolean;
  };
}

export const deleteAllocation = (
  client: ApolloClient<object>,
  allocationId: number | string,
) => {
  return client.mutate<DeleteAllocationResponse, DeleteAllocationVariables>({
    mutation,
    variables: { allocationId },
    fetchPolicy: 'no-cache',
  });
};
